import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";
import { LocationItem } from "core/http/service/location/resTypes";

interface DataState {
  [code: string]: LocationItem[];
}

interface LocationState {
  data: DataState;
  status: ReduxStateType;
}

interface InitialState {
  province: LocationState;
  district: LocationState;
  ward: LocationState;
}

interface LocationPayload {
  key: string;
  data: LocationItem[];
}

const initialLocationState: LocationState = {
  data: {},
  status: ReduxStateType.INIT,
};

const initialState: InitialState = {
  province: { ...initialLocationState },
  district: { ...initialLocationState },
  ward: { ...initialLocationState },
};

const setLoadingStatus = (state: LocationState) => {
  state.status = ReduxStateType.LOADING;
};

const setErrorStatus = (state: LocationState) => {
  state.status = ReduxStateType.ERROR;
};

const getLocationSlice = createSlice({
  name: "getLocation",
  initialState,
  reducers: {
    getProvinceStart: (state) => setLoadingStatus(state.province),
    getProvinceSuccess: (state, action: PayloadAction<LocationPayload>) => {
      state.province.status = ReduxStateType.SUCCESS;

      state.province.data = {
        ...state.province.data,
        [action.payload.key]: action.payload.data,
      };
    },
    getProvinceFailed: (state) => setErrorStatus(state.province),

    getDistrictStart: (state) => setLoadingStatus(state.district),
    getDistrictSuccess: (state, action: PayloadAction<LocationPayload>) => {
      state.district.status = ReduxStateType.SUCCESS;

      state.district.data = {
        ...state.district.data,
        [action.payload.key]: action.payload.data,
      };
    },
    getDistrictFailed: (state) => setErrorStatus(state.district),

    getWardStart: (state) => setLoadingStatus(state.ward),
    getWardSuccess: (state, action: PayloadAction<LocationPayload>) => {
      state.ward.status = ReduxStateType.SUCCESS;

      state.ward.data = {
        ...state.ward.data,
        [action.payload.key]: action.payload.data,
      };
    },
    getWardFailed: (state) => setErrorStatus(state.ward),

    resetLocationState: () => {
      return { ...initialState };
    },
  },
});

export const {
  getProvinceStart,
  getDistrictStart,
  getWardStart,
  getProvinceSuccess,
  getDistrictSuccess,
  getWardSuccess,
  getProvinceFailed,
  getDistrictFailed,
  getWardFailed,
  resetLocationState,
} = getLocationSlice.actions;

export default getLocationSlice.reducer;
